import { keys } from "@/lib/i18n/portal";
import type { SmartBucketId } from "@/lib/api/types";
import type { StatusToneEntry } from "./order-status-display";

/** Re-export for consumers that want the type without importing from the API
 * layer directly. */
export type { SmartBucketId };

/** Visual/i18n metadata for each smart bucket.
 * Mirrors the shape of {@link StatusToneEntry} from `order-status-display.ts`
 * so that rendering components can use a single chip component for both
 * per-row status badges and smart-bucket section headers. */
export const SMART_BUCKET_TONE: Record<SmartBucketId, StatusToneEntry> = {
  needs_attention: {
    labelKey: keys.orders.smartBucketNeedsAttention,
    dot: "var(--accent-500)",
    bg: "oklch(0.96 0.05 75)",
    fg: "var(--accent-600)",
  },
  waiting_on_buyer: {
    labelKey: keys.orders.waitingOnBuyerSectionLabel,
    dot: "#64748b",
    bg: "oklch(0.96 0.02 250)",
    fg: "#475569",
  },
  in_fulfillment: {
    labelKey: keys.orders.smartBucketInFulfillment,
    dot: "#3b82f6",
    bg: "oklch(0.96 0.04 240)",
    fg: "#1d4ed8",
  },
  shipped: {
    labelKey: keys.orders.smartBucketShipped,
    dot: "var(--success-500)",
    bg: "oklch(0.96 0.04 155)",
    fg: "var(--success-500)",
  },
  closed: {
    labelKey: keys.orders.smartBucketClosed,
    dot: "#6b7280",
    bg: "oklch(0.96 0.01 240)",
    fg: "#374151",
  },
};

/** Priority-ordered list of smart bucket ids (lowest priority number first —
 * `needs_attention` appears at the top of the Smart View). */
export const SMART_BUCKETS_ORDERED: SmartBucketId[] = [
  "needs_attention",
  "waiting_on_buyer",
  "in_fulfillment",
  "shipped",
  "closed",
];
